<template>
  <div class="episode-player">
    <div class="episode-player__meta">
      <div class="episode-player__desc">
        <div class="episode-player__recording">
          <div class="episode-player__date">
            {{ useFormatDate('fullDate', start) }}
          </div>
          <div class="episode-player__duration">
            {{ duration }}
          </div>
          <NuxtLink v-if="show" :to="show.path.alias" class="episode-player__show-link">
            Sendungsformat
          </NuxtLink>
        </div>
        <div class="episode-player__meta">
          <div v-if="icons.length || repeat" class="episode-player__categories-list">
            <div v-for="(icon) in icons" :key="`episode-player__category--${icon.uuid}`"
              class="episode-player__category">
              <Icon :name="`${icon.label}`" />
            </div>
            <div v-if="repeat" class="episode-player__category">
              <Icon name="Repetition" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="episode-player__player">
      <AudioPlayer >
        <hls-audio class="episode-player__audio" :src controls></hls-audio>
      </AudioPlayer>
    </div>
  </div>
</template>

<script setup lang="ts">
import '@videojs/html/media/hls-audio';
import '@videojs/html/ui/container';
import { isPast } from 'date-fns';
import { defineProps, } from 'vue';


const props = defineProps<{
  tags: {
    label: string
  }
  languages: [
    {
      uuid: string
      label: string
    },
  ]
  show: {
    uuid: string
    url: {
      path: string
    }
  }
  start: string
  end: string
  repeat: boolean
}>()

const icons = computed(() => {
  return props.tags.map((tag) => {
    return {
      label: useCategoryIcon(tag.label),
      uuid: tag.uuid,
    }
  }).filter((icon) => {
    return icon.label !== undefined
  })
})

const src = computed(() => {
  return `https://archiv.loratech.ch/sendungen/${useFormatDate('archiveDate', props.start)}/${useFormatDate('archiveTime', props.start)}.m3u8`
})

const duration = computed(() => {
  return useFormatDuration(props.start, props.end)
})

const isEpisodePast = isPast(`${props.end}Z`)

const isPlaying = ref(false)
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.episode-player {
  &__inner {
    display: flex;
    align-items: flex-start;
    gap: calc(var(--space--m) / 2);
  }

  &__desc {
    display: flex;
    flex-direction: column;
    gap: var(--space--xs);
  }

  &__recording {
    display: grid;
    grid-template-columns: repeat(3, auto);
    gap: 0 var(--grid-gutter);
  }

  &__show-link {
    @include tools.to(tools.$breakpoint--desktop) {
      grid-row: 2;
      grid-column: span 2;
    }
  }

  &__meta {
    display: flex;
    align-items: flex-start;
    gap: var(--space--s);

    @include tools.to(tools.$breakpoint--desktop) {
      flex-direction: column;
    }
  }

  &__categories-list,
  &__languages-list {
    display: flex;
    gap: var(--space--s);
    flex-wrap: wrap;
  }

  &__language {
    @include tools.tag;
  }

  &__player {
    margin-top: var(--space--s);
    max-width: 500px;
  }

  &__player,
  &__audio {
    width: 100%;
  }

  &__audio {
    display: none;
  }
}
</style>
